import React from 'react';

interface LogoutConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onCancel}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.iconContainer}>
          <span style={styles.icon}>🚪</span>
        </div>
        
        <h2 style={styles.title}>Sign Out</h2>
        <p style={styles.message}>
          Are you sure you want to sign out? You'll need to log in again to access your account.
        </p>
        
        <div style={styles.buttonContainer}>
          <button
            style={styles.cancelButton}
            onClick={onCancel}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f9fafb';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#fff';
            }}
          >
            Cancel
          </button>
          <button
            style={styles.confirmButton}
            onClick={onConfirm}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#b91c1c';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#dc2626';
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    backdropFilter: 'blur(4px)',
  },
  modal: {
    background: '#fff',
    borderRadius: '16px',
    padding: '32px',
    maxWidth: '420px',
    width: '90%',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    animation: 'slideIn 0.2s ease-out',
  },
  iconContainer: {
    textAlign: 'center' as const,
    marginBottom: '16px',
  },
  icon: {
    fontSize: '48px',
    display: 'inline-block',
  },
  title: {
    margin: '0 0 12px 0',
    fontSize: '24px',
    fontWeight: 600,
    color: '#1f2937',
    textAlign: 'center' as const,
  },
  message: {
    margin: '0 0 24px 0',
    fontSize: '15px',
    color: '#6b7280',
    textAlign: 'center' as const,
    lineHeight: 1.6,
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'stretch',
  },
  cancelButton: {
    flex: 1,
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: 600,
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#fff',
    color: '#374151',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  cancelButtonHover: {
    background: '#f9fafb',
  },
  confirmButton: {
    flex: 1,
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '10px',
    background: '#dc2626',
    color: '#fff',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
  },
  confirmButtonHover: {
    background: '#b91c1c',
  },
};

export default LogoutConfirmationModal;

